import React, { Component } from "react"
import ClassificationContainer from "components/classifications/redux/ClassificationContainers"

export class ClassificationPage extends Component {
    render() { return (<ClassificationContainer />) }
}
